import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { useSelector } from 'react-redux';
import { YOUR_BASKET } from '../../brands/default/content/components/checkout';
import { trackEvent } from '../../helpers/analytics';
import {
  getGiftWrap,
  getDeliveryOptionsFromProducts,
} from '../../helpers/checkout';
import ThemeContext from '../../providers/ThemeProvider';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';
import Tile from '../_generic/tile/Tile';
import TileTitle from '../_generic/tile/TileTitle';
import BasketDeal from './BasketDeal';
import EmptyBasket from './EmptyBasket';
import WowcherVipCue from './WowcherVipCue';

export default function Basket({
  bt,
  status,
  isAuthenticated,
  isVipUser,
  deals,
  site,
  isRedeemPostage,
  currencySymbol,
  isMobile,
  finalOrderAmount,
  isExpressCheckout,
  welcomeVipEnabled = false,
}) {
  const theme = useContext(ThemeContext);
  const giftWrapPreset = useSelector((state) => state.checkout.giftWrapPreset);
  const giftWrap = getGiftWrap(deals);
  const [firstLoad, setFirstLoad] = useState(true);
  const productDeliveryOptions = getDeliveryOptionsFromProducts(deals);

  if (productDeliveryOptions && firstLoad) {
    setFirstLoad(false);
    trackEvent('HAS_DELIVERY_OPTIONS');
  }

  return (
    <>
      <Tile
        extraClasses="basket"
        title={
          <TileTitle
            rightNode={isVipUser && isAuthenticated && <WowcherVipCue />}
            title={
              !isAuthenticated &&
              isMobile &&
              finalOrderAmount &&
              isExpressCheckout
                ? YOUR_BASKET +
                  ' : ' +
                  currencySymbol +
                  finalOrderAmount?.toFixed(2)
                : YOUR_BASKET
            }
          />
        }
      >
        <ReactPlaceholder
          ready={status !== CHECKOUT_STATUS.LOADING}
          showLoadingAnimation
          style={{ padding: 15 }}
        >
          {deals.length === 0 && (
            <EmptyBasket isAuthenticated={isAuthenticated} />
          )}
          {deals.length > 0 && (
            <div className="basket__content">
              {deals.map((deal) => {
                return (
                  <BasketDeal
                    bt={bt}
                    deal={deal}
                    deals={deals}
                    giftWrap={giftWrap || giftWrapPreset}
                    isAuthenticated={isAuthenticated}
                    isRedeemPostage={isRedeemPostage}
                    key={deal.id}
                    site={site}
                    welcomeVipEnabled={welcomeVipEnabled}
                  />
                );
              })}
            </div>
          )}
        </ReactPlaceholder>
      </Tile>
      <style jsx>{`
        :global(.tile--basket) {
          margin-bottom: 30px;
        }
        .basket__content {
          border-bottom: 6px solid ${theme.colors.primary};
          border-radius: inherit;
        }
        .titleWrapper {
          display: flex;
          flex-direction: row;
        }
        .basket-total {
          color: black;
          font-size: 15px;
          margin-left: 3px;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          :global(.tile--basket) {
            margin-bottom: 0;
          }
        }
      `}</style>
    </>
  );
}

Basket.propTypes = {
  bt: PropTypes.string,
  deals: PropTypes.arrayOf(PropTypes.object).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isRedeemPostage: PropTypes.bool,
  isVipUser: PropTypes.bool,
  site: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};
